import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton, PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and, not } from 'ember-truth-helpers';
import HotelBenchmarkInsightCardOverlay from 'lumen/components/hotel/benchmark-insight/card-overlay';

interface HotelBenchmarkInsightSectionsSectionPaceSectionPaceOverlaySignature {
  Args: {};
}

export default class HotelBenchmarkInsightSectionsSectionPaceSectionPaceOverlay extends Component<HotelBenchmarkInsightSectionsSectionPaceSectionPaceOverlaySignature> {
  @service declare access: Services['access'];
  @service('benchmark-insight/trial')
  declare benchmarkInsightTrial: Services['benchmark-insight/trial'];

  @service declare intercom: Services['intercom'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get messageDescription() {
    if (this.benchmarkInsightTrial.hasRequestedTrial) {
      return this.intl.t(
        'benchmark_insight.light.banner_trial.message.requested',
      );
    }

    return this.intl.t(
      'benchmark_insight.light.section_pace_overlay.description',
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get messageTitle() {
    if (this.benchmarkInsightTrial.hasRequestedTrial) {
      return this.intl.t(
        'benchmark_insight.light.section_pace_overlay.title.requested',
      );
    }

    return this.intl.t('benchmark_insight.light.section_pace_overlay.title');
  }

  @action
  onClickLearnMore(): void {
    this.intercom.redirectToIntercomHelp(
      'en/articles/8272072-get-started-with-benchmark-insight',
    );
  }

  <template>
    <HotelBenchmarkInsightCardOverlay>
      <PrismMessage
        @description={{this.messageDescription}}
        @illustration="100x100_rocket"
        @title={{this.messageTitle}}
        data-test-id="section-pace-overlay"
      >
        <:primaryAction>
          {{#if
            (and
              this.access.hasBenchmarkInsightTrialUpsellEdit
              (not this.benchmarkInsightTrial.hasRequestedTrial)
            )
          }}
            <PrismButton
              @buttonType="brand"
              @iconAfter="arrow-right"
              @isDisabled={{this.benchmarkInsightTrial.saveBeniUpsellRecordTask.isRunning}}
              @isLoading={{this.benchmarkInsightTrial.saveBeniUpsellRecordTask.isRunning}}
              @label={{t "benchmark_insight.light.get_in_touch"}}
              {{on "click" this.benchmarkInsightTrial.onClickStartTrial}}
            />
          {{else}}
            <PrismButton
              @buttonType="brand"
              @label={{t "benchmark_insight.upsell.banner.button.learn_more"}}
              {{on "click" this.benchmarkInsightTrial.openHelpArticle}}
            />
          {{/if}}
        </:primaryAction>
      </PrismMessage>
    </HotelBenchmarkInsightCardOverlay>
  </template>
}
